import styled from 'styled-components';
import { CALYPSO } from 'HubStyleTokens/colors';
// @ts-expect-error Untyped import
import circlesImageUrl from 'bender-url!../../images/white-circle-3.svg';
import { jsx as _jsx } from "react/jsx-runtime";
const ColorCirclesHeader = styled(({
  children,
  className
}) => /*#__PURE__*/_jsx("div", {
  className: className,
  children: /*#__PURE__*/_jsx("div", {
    className: "cch-inner",
    children: children
  })
})).withConfig({
  displayName: "ColorCirclesHeader",
  componentId: "sc-1uzye7n-0"
})(["background-color:", ";padding:55px 0 65px 0;position:relative;&::before{content:'';display:block;top:0;left:0;width:100%;height:100%;position:absolute;background-image:url(", ");background-size:cover;background-position:center;background-repeat:no-repeat;background-blend-mode:overlay;opacity:0.07;z-index:0;}.cch-inner{position:relative;}"], CALYPSO, circlesImageUrl);
export default ColorCirclesHeader;